import React, { useEffect, useState } from 'react'
import RightModal from '../../../../components/Modals/RightModal';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg';
import InputText from '../../../../components/InputGroup/InputText';
import MobileInput from '../../../../components/InputGroup/MobileInput';
import { inviteUserViaEmail } from '../../../../services/private/plus.leads.service';

const InviteUserModal = ({ show, closeModal, getUsers, selectedUser }) => {
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [error, setError] = useState();
    const [email, setEmail] = useState('');

    useEffect(() => {
        if (Object.keys(selectedUser).length) {
            setName(selectedUser?.name || '');
            setMobile(selectedUser?.mobile || '')
        }
    }, [selectedUser]);

    const handleSubmit = async () => {
        if (!name || !mobile) {
            setError(true);
            return;
        } else {
            setError(false);

        }
        const payload = {
            mobile: mobile,
            name: name,
            email: email
        }
        const res = await inviteUserViaEmail(payload);
        if (res.data.status === 200) {
            console.log(res.data.data, 'invite');
            getUsers()
            closeModal();
        }
    }


    return (
        <RightModal
            show={show}
            closeModal={closeModal}
        >
            <div className='flex flex-col h-full overflow-hidden'>
                <div className='h-full overflow-auto'>
                    <div className='d-flex border-b justify-content-between !px-5 !py-4'>
                        <h1 className='text-black text-2xl inter m-0'>Add User</h1>
                        <button className='border-0 bg-tr ' onClick={() => {
                            closeModal();
                        }}><CloseIcon /></button>
                    </div>
                    <div className='!px-5 !mt-5'>
                        <InputText
                            label='Name'
                            placeholder='Enter Name'
                            required={true}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={error && !name ? 'Please Enter Name' : ''}
                        />

                        <MobileInput
                            label='Mobile'
                            required={true}
                            inputclass='!w-full'
                            value={mobile}
                            onChange={(phone) => setMobile(phone.phone)}
                            error={error && !mobile ? 'Please Enter Mobile' : ''}
                        />
                        <InputText
                            label='Email'
                            placeholder='Enter Email'
                            // required={true}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        // error={error && !email ? 'Please Enter email' : ''}
                        />
                    </div>
                </div>
                <div className="flex items-center !py-5 !px-5 !w-full">

                    <button
                        className="cancel outline-btn !w-1/2  !py-2 mr-2"
                        onClick={closeModal}
                    >
                        Cancel
                    </button>
                    <button
                        className="pr-btn !w-1/2 !py-2"
                        type="submit"
                        onClick={handleSubmit}
                    >
                        Confirm
                    </button>

                </div>
            </div>
        </RightModal>
    )
}

export default InviteUserModal